import * as R from "ramda";
import React, { Component } from "react";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleTextArea from "../../../modules/simpleTextArea";
import Api from "../../../Services/Api";
import { ACTIVITY_TYPE } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterSuppliersModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      jenisSupplierOptions: [],
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "SUPPLIER_TYPE",
        },
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: responses[0].data.data.map((c) =>
          mapToObjectDDL(c.namaDealer, c.kodeCabang)
        ),
      }));
    }

    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        jenisSupplierOptions: responses[1].data.data.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      }));
    }
  }

  handleSubmit = () => {
    if (this.props.validate()) {
      this.props.onSubmit(this.props.controls);
    }
  };

  render() {
    const { errors } = this.props;
    return (
      <SimpleModal
        title={`${this.props.activity} Supplier/Vendor`}
        visible={this.props.visible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_kode_supplier"
                name="supplierCode"
                label="Kode Supplier"
                mandatory
                readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                errorMessage={errors.supplierCode}
                value={this.props.controls.supplierCode.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_nama_supplier"
                name="supplierName"
                label="Nama Supplier"
                mandatory
                errorMessage={errors.supplierName}
                value={this.props.controls.supplierName.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleTextArea
                typeInputCase="normal"
                id="input_text_alamat"
                name="address"
                label="Alamat"
                value={this.props.controls.address.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_email"
                name="email"
                label="Email"
                value={this.props.controls.email.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_jenis_supplier"
                name="jenisSupplier"
                label="Jenis Supplier"
                box="search"
                mandatory
                errorMessage={errors.jenisSupplier}
                options={this.state.jenisSupplierOptions}
                value={this.props.controls.jenisSupplier.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
              />
              <SimpleInput
                id="input_text_nama_pic"
                name="namaPic"
                label="Nama PIC"
                mandatory
                errorMessage={errors.namaPic}
                value={this.props.controls.namaPic.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_telepon"
                name="phone"
                label="Telepon"
                box="onlyNumber"
                maxLength={14}
                value={this.props.controls.phone.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_jabatan"
                name="jabatan"
                label="Jabatan"
                value={this.props.controls.jabatan.value}
                onChange={({ target }) =>
                  this.props.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_untuk_cabang"
                name="cabang"
                label="Untuk Cabang"
                box="multiselect"
                options={this.state.cabangOptions}
                value={this.props.controls.cabang.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
              />
              <div style={{ textAlign: "center" }}>
                <SimpleButton
                  type="button"
                  secondary
                  onClick={this.props.reset}
                >
                  Hapus
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
              </div>
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(MasterSuppliersModifying);
